import React from 'react';
import { Col } from 'react-bootstrap';
import config from '../../../config';
import { v4 as uuidv4 } from 'uuid';
import QualityCheckAnswerButton from 'dashboard/processing/components/QualityCheckAnswerButton';
import _ from 'lodash';

const ConditionQuestionComponent = (props) => {
  const {
    Text = '',
    ItemNumber = '',
    QualityCheckImages = [],
    CustomHTML = '',
    DeterministicQualityCheck = { Answers: [] },
  } = props.qualityCheckRecord;
  const answersInChunks = _.chunk(DeterministicQualityCheck.Answers, 2);
  return (
    <div className="product-question">
      <div>
        <div
          className="quality-check-prompt"
          data-item-number={ItemNumber}
          data-testid={`quality-check-prompt-${props.qualityCheckRecord.qualityCheckType}`}
        >
          {`${Text}${
            config.getEnvironmentName() == 'production' || config.getEnvironmentName() == 'test'
              ? ''
              :  ` ${ItemNumber} ${props.qualityCheckRecord.qualityCheckType}`
          }`}
        </div>
        {CustomHTML !== '' &&
          <RenderHTML  HTML={CustomHTML}></RenderHTML>
        }
        {QualityCheckImages.map((image, index) => {
          return (
            <span
              style={{
                'border-radius': 10,
              }}
              key={index}
              className="pright15"
            >
              <img
                className="bot20"
                data-testid={'quality-check-image'}
                style={{
                  'max-height': 350,
                  'max-width': '100%',
                }}
                src={image.URL}
              />
            </span>
          );
        })}

        <Col xs={12} className="bot30 top30">
          {answersInChunks.map((answersChunk) =>
            <div
                key={uuidv4()}
                style={{ flexWrap: 'wrap' }}
                className="set-width flex-box  align-center space-around text-left bot20"
              >
                {answersChunk.map((answer) => (
                  <QualityCheckAnswerButton key={uuidv4()} {...props} currentAnswer={answer}></QualityCheckAnswerButton>
                ))}
              </div>
            )}
        </Col>
        <div className="top30 bot30">{props.displayCustomInputs()}</div>
      </div>
    </div>
  );
};

const RenderHTML = (props) => (<div data-testid='custom-html-content' style={{overflow:'auto'}} className="top15 bot15" dangerouslySetInnerHTML={{__html:props.HTML}}></div>);

export default ConditionQuestionComponent;
